





























































































































































































import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import {
  TreatmentMonitoringApi,
  TreatmentProceedTimeModel,
} from "../../../apis";
import { VueExcelEco2 } from "../common/VueExcelEco2";
import MyDateTimePickerMobile from "../mobile/common/MyDateTimePickerMobile.vue";
@Component({
  components: { MyDateTimePickerMobile },
})
export default class ProcessTime extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({ default: () => {} }) unit: any;
  @Prop({ default: () => {} }) variables: { text: string; value: string }[];
  @Prop({ default: () => [] }) treatments: { text: string; value: string }[];
  selectedVariables: TreatmentProceedTimeModel[] = [];
  searchForm = {
    dateFrom: "",
    dateTo: "",
    variableId: "",
    treatmentId: "",
  };
  proceedTimes: TreatmentProceedTimeModel[] = [];
  totalProcessTime: number = 0;

  page = 1;
  pageCount = 0;
  itemsPerPage = 10;

  get show() {
    const today = new Date();
    this.searchForm.dateTo = moment(today)
      .startOf("days")
      .add(1, "days")
      .format("YYYY-MM-DD HH:mm");
    this.searchForm.dateFrom = moment(today)
      .startOf("days")
      .add(-7, "days")
      .format("YYYY-MM-DD HH:mm");
    this.searchForm.variableId = "";
    this.searchForm.treatmentId = "";
    this.proceedTimes = [];
    this.pageCount = 0;
    this.page = 1;
    this.totalProcessTime = 0;

    return this.value;
  }

  // Tính từ selectedVariables (checkbox) - giữ nguyên logic cũ
  get totalTime() {
    if (this.selectedVariables.length > 0) {
      let mins = 0;
      let hs = 0;
      for (let index = 0; index < this.selectedVariables.length; index++) {
        try {
          const element = this.selectedVariables[index].proceedTime.split(":");
          hs = hs + Number(element[0]);
          mins = mins + Number(element[1]);
        } catch (error) {}
      }
      if (mins >= 60) {
        hs = hs + Math.floor(mins / 60);
        mins = mins % 60;
      }
      return hs + "h" + mins + "m";
    }
    return "0h0m";
  }

  // Hiển thị totalProcessTime từ API response (tổng của toàn bộ kết quả)
  get totalProcessTimeDisplay() {
    if (this.totalProcessTime > 0) {
      const totalMs = this.totalProcessTime;
      const hours = Math.floor(totalMs / (1000 * 60 * 60));
      const minutes = Math.floor((totalMs % (1000 * 60 * 60)) / (1000 * 60));
      return hours + "h" + minutes + "m";
    }
    return "";
  }

  set show(value) {
    this.$emit("input", value);
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  get HEADERS() {
    return [
      {
        text: this.$t("text.fromDate"),
        value: "startDate",
      },
      {
        text: this.$t("text.toDate"),
        value: "endDate",
      },
      {
        text: this.$t("text.proceedTimeHHmm"),
        value: "proceedTime",
      },
      { text: "", value: (this.$screen.isMobile() && this.proceedTimes.length > 0) || !this.$screen.isMobile() ? "data-table-select" : "" },
    ] as DataTableHeader[];
  }

  async doSearch() {
    if (!this.searchForm.variableId) return;
    this.$util.showLoading();
    try {
      this.selectedVariables = [];
      const rs = await new TreatmentMonitoringApi().getTreatmentProceedTime({
        limit: this.itemsPerPage,
        page: this.page,
        orderBy: "startDate",
        orderDesc: "true",
        variableId: this.searchForm.variableId,
        treatmentId: this.searchForm.treatmentId || undefined,
        startDate: !this.searchForm.dateFrom
          ? ""
          : moment(this.searchForm.dateFrom, "YYYY-MM-DD HH:mm")
              .utc()
              .format("YYYY-MM-DD HH:mm"),
        endDate: !this.searchForm.dateTo
          ? ""
          : moment(this.searchForm.dateTo, "YYYY-MM-DD HH:mm")
              .utc()
              .format("YYYY-MM-DD HH:mm"),
      });
      if (this.lodash.isEmpty(rs.data.data)) {
        this.proceedTimes = [];
      }
      this.proceedTimes = rs.data.data;
      this.proceedTimes.forEach((item, index) => (item["id"] = index));
      this.selectedVariables = this.proceedTimes;
      // Get totalProcessTime from response if available
      this.totalProcessTime = (rs.data as any).totalProcessTime || 0;
      this.pageCount =
        Math.floor(rs.data.count / this.itemsPerPage) +
        (rs.data.count % this.itemsPerPage > 0 ? 1 : 0);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
  columnsExport = [
    {
      label: this.$t("text.fromDate"),
      field: "startDate",
    },
    {
      label: this.$t("text.toDate"),
      field: "endDate",
    },
    {
      label: this.$t("text.proceedTimeHHmm"),
      field: "proceedTime",
    },
  ];
  dataExport = [];
  async doExport() {
    if (!this.searchForm.variableId) return;
    this.$util.showLoading();
    this.dataExport = [];
    try {
      const rs = await new TreatmentMonitoringApi().getTreatmentProceedTime({
        limit: null,
        page: 1,
        orderBy: "startDate",
        orderDesc: "true",
        variableId: this.searchForm.variableId,
        treatmentId: this.searchForm.treatmentId || undefined,
        startDate: !this.searchForm.dateFrom
          ? ""
          : moment(this.searchForm.dateFrom, "YYYY-MM-DD HH:mm")
              .utc()
              .format("YYYY-MM-DD HH:mm"),
        endDate: !this.searchForm.dateTo
          ? ""
          : moment(this.searchForm.dateTo, "YYYY-MM-DD HH:mm")
              .utc()
              .format("YYYY-MM-DD HH:mm"),
      });

      if (this.lodash.isEmpty(rs.data.data)) {
        this.proceedTimes = [];
      }
      this.dataExport = rs.data.data.map((item) => {
        return {
          ...item,
          startDate: this.$moment(item.startDate).format("DD/MM/YYYY HH:mm:ss"),
          endDate: this.$moment(item.endDate).format("DD/MM/YYYY HH:mm:ss"),
        };
      });

      // Get totalProcessTime from response and add summary row
      const totalProcessTimeMs = (rs.data as any).totalProcessTime || 0;
      if (totalProcessTimeMs > 0) {
        const totalHours = Math.floor(totalProcessTimeMs / (1000 * 60 * 60));
        const totalMinutes = Math.floor((totalProcessTimeMs % (1000 * 60 * 60)) / (1000 * 60));
        const totalTimeFormatted = totalHours + ":" + (totalMinutes < 10 ? "0" : "") + totalMinutes;
        
        // Add summary row at the end
        this.dataExport.push({
          startDate: this.$t("text.total") || "Total",
          endDate: "",
          proceedTime: totalTimeFormatted,
        });
      }
    } catch (error) {
      this.$util.showError(error);
    } finally {
      const variable = this.variables.find(
        (v) => v.value == this.searchForm.variableId
      ).text;
      const unitInfo = this.unit
        ? " [" + this.unit.location.locationName + "][" + this.unit.name + "]"
        : "";
      const exportExcel = new VueExcelEco2(
        "ECO2 - Export Process Time [" + variable + "]" + unitInfo,
        "xlsx",
        "ECO2 Web",
        this.dataExport,
        this.columnsExport
      ).exportExcel();
      this.$util.hideLoading();
    }
  }
}
